import Vue from 'vue'
import Router from 'vue-router'

import LoginComponent from '@/components/Login'
import RegisterComponent from '@/components/Register'
import DashboardComponent from '@/components/Dashboard'

import CoinsComponent from '@/components/Coin/Coins'
import CoinsCountryComponent from '@/components/Coin/CoinsCountry'
import CoinsContinentComponent from '@/components/Coin/CoinsContinent'
import CoinShowComponent from '@/components/Coin/CoinShow'
import CoinEditComponent from '@/components/Coin/CoinEdit'
import CoinNewComponent from '@/components/Coin/CoinNew'

import BanknotesComponent from '@/components/Banknote/Banknotes'
import BanknotesContinentComponent from '@/components/Banknote/BanknotesContinent'
import BanknotesCountryComponent from '@/components/Banknote/BanknotesCountry'
import BanknoteShowComponent from '@/components/Banknote/BanknoteShow'
import BanknoteEditComponent from '@/components/Banknote/BanknoteEdit'
import BanknoteNewComponent from '@/components/Banknote/BanknoteNew'

import BooksComponent from '@/components/Book/Books'
import BookShowComponent from '@/components/Book/BookShow'

import UserProfileComponent from '@/components/User/Profile'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: { name: 'login' }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginComponent
    },
    {
      path: '/register',
      name: 'register',
      component: RegisterComponent
    },
    {
      path: '/dashboard',
      name: 'home',
      component: DashboardComponent,
      meta: { requiresAuth: true }
    },
    {
      path: '/coins',
      name: 'coin',
      component: CoinsComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/coins/continent/:code',
      name: 'coin.continent',
      component: CoinsContinentComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/coins/country/:code',
      name: 'coin.country',
      component: CoinsCountryComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/coins/show/:key',
      name: 'coin.show',
      component: CoinShowComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/coins/edit/:key',
      name: 'coin.edit',
      component: CoinEditComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/coins/new',
      name: 'coin.new',
      component: CoinNewComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/banknotes',
      name: 'banknote',
      component: BanknotesComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/banknotes/continent/:code',
      name: 'banknote.continent',
      component: BanknotesContinentComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/banknotes/country/:code',
      name: 'banknote.country',
      component: BanknotesCountryComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/banknotes/show/:key',
      name: 'banknote.show',
      component: BanknoteShowComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/banknotes/edit/:key',
      name: 'banknote.edit',
      component: BanknoteEditComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/banknotes/new',
      name: 'banknote.new',
      component: BanknoteNewComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/books',
      name: 'book',
      component: BooksComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/books/show/:key',
      name: 'book.show',
      component: BookShowComponent,
      meta: { requiresAuth: true },
      fallback: false
    },
    {
      path: '/user/profile/:uid',
      name: 'user.profile',
      component: UserProfileComponent,
      meta: { requiresAuth: true },
      fallback: false
    }
  ]
})

router.beforeEach((to, from, next) => {
  localStorage.removeItem('back')
  localStorage.removeItem('params')
  localStorage.back = from.name
  localStorage.params = Object.getOwnPropertyNames(from.params).length > 0 ? JSON.stringify(from.params) : '{}'
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js